"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Pagination = {
  styles: function styles(theme) {
    return {
      pageIndicator: {
        borderRadius: 0,
        color: theme.colors.primary,
        fontSize: theme.typography.fontSize,
        width: 30,
        height: 36,
        "&:hover": {
          // hover state background color for page number
          backgroundColor: theme.colors.baseContrast010
        }
      },
      dotsIconWrapper: {
        width: 30,
        height: 36
      },
      dotsIcon: {
        minWidth: theme.spacing.base * 2.9,
        minHeight: theme.spacing.base * 2.9,
        width: theme.spacing.base * 2.9,
        height: theme.spacing.base * 2.9,
        marginTop: 1
      },
      pageChanger: {
        borderRadius: 0,
        backgroundColor: "transparent",
        width: 30,
        height: 36,
        "&:hover": {
          // hover state background color for prev/next
          backgroundColor: theme.colors.baseContrast010,
          "& $pageChangerIcon": {
            // hover state icon color for prev/next
            fill: theme.colors.primary
          }
        }
      },
      pageChangerIcon: {
        minWidth: theme.spacing.base * 2.9,
        minHeight: theme.spacing.base * 2.9,
        width: theme.spacing.base * 2.9,
        height: theme.spacing.base * 2.9
      },
      padRight: {
        // eslint-disable-next-line @atg/css-rtl-support
        marginRight: 2
      },
      padLeft: {
        // eslint-disable-next-line @atg/css-rtl-support
        marginLeft: 2
      }
    };
  }
};
var _default = exports.default = Pagination;